import { httpRequest, RequestConfig } from '../request';

export function getServiceTypeList(data?: any, headers?: any) {
  const config: RequestConfig = {
    url: 'self-service/overseas-store/service-type/list',
    method: 'post',
    data
  };
  headers && (config.headers = headers);

  return httpRequest(config);
}

export function getProductTypeList(data?: any, headers?: any) {
  const config: RequestConfig = {
    url: 'self-service/overseas-store/service-code/list',
    method: 'post',
    data
  };
  headers && (config.headers = headers);

  return httpRequest(config);
}

export function searchNearList(data: any, headers?: any) {
  const config: RequestConfig = {
    url: 'self-service/map/search/near-list',
    data,
    method: 'post'
  };
  headers && (config.headers = headers);
  return httpRequest(config);
}

export function getOverseasStoreList(data?: any, headers?: any) {
  const config: RequestConfig = {
    url: 'self-service/overseas-store/list',
    data,
    method: 'post'
  };
  headers && (config.headers = headers);
  return httpRequest(config);
}

export function getDetailData(data: any, headers?: any) {
  const config: RequestConfig = {
    url: 'self-service/overseas-store/detail',
    method: 'post',
    data
  };
  headers && (config.headers = headers);
  return httpRequest(config);
}
